module.exports = __webpack_public_path__ + "static/img/d-sperse-logo.4ba87464.jpg";